/* Centralized data-testid map (single source of truth for QA). */
export const TID = {
  // Landing
  landingGoMaster: "landing-go-master",
  landingTenantSlug: "landing-tenant-slug",
  landingGoTenant: "landing-go-tenant",

  // Auth — Master
  masterLoginForm: "master-login-form",
  masterLoginEmail: "master-login-email",
  masterLoginPassword: "master-login-password",
  masterLoginSubmit: "master-login-submit",
  masterLoginError: "master-login-error",

  // Auth — Tenant
  tenantLoginForm: "tenant-login-form",
  tenantLoginEmail: "tenant-login-email",
  tenantLoginPassword: "tenant-login-password",
  tenantLoginSubmit: "tenant-login-submit",
  tenantLoginError: "tenant-login-error",

  // Master layout
  masterSidebar: "master-sidebar",
  masterLogout: "master-logout",
  masterNavDashboard: "master-nav-dashboard",
  masterNavTenants: "master-nav-tenants",
  masterNavTemplates: "master-nav-templates",
  masterNavAudit: "master-nav-audit",

  // Master Dashboard
  masterStatsMrr: "master-stats-mrr",
  masterStatsTenants: "master-stats-tenants",
  masterStatsChurn: "master-stats-churn",
  masterStatsUsers: "master-stats-users",

  // Master Tenants
  tenantsTable: "tenants-table",
  tenantsCreateBtn: "tenants-create-btn",
  tenantCreateDialog: "tenant-create-dialog",
  tenantCreateSlug: "tenant-create-slug",
  tenantCreateLegalName: "tenant-create-legal-name",
  tenantCreateVertical: "tenant-create-vertical",
  tenantCreateAdminEmail: "tenant-create-admin-email",
  tenantCreateAdminPassword: "tenant-create-admin-password",
  tenantCreateSubmit: "tenant-create-submit",
  tenantRow: (id) => `tenant-row-${id}`,
  tenantOpenDetail: (id) => `tenant-open-${id}`,
  tenantSuspendBtn: (id) => `tenant-suspend-${id}`,
  tenantReactivateBtn: (id) => `tenant-reactivate-${id}`,
  tenantImpersonateBtn: (id) => `tenant-impersonate-${id}`,

  // Tenant layout
  tenantSidebar: "tenant-sidebar",
  tenantLogout: "tenant-logout",
  tenantNavDashboard: "tenant-nav-dashboard",
  tenantNavSettings: "tenant-nav-settings",
  tenantNavAudit: "tenant-nav-audit",

  // Tenant Settings (tabs)
  settingsTabBranding: "settings-tab-branding",
  settingsTabModules: "settings-tab-modules",
  settingsTabFields: "settings-tab-fields",
  brandingDisplayName: "branding-display-name",
  brandingPrimaryColor: "branding-primary-color",
  brandingLoginHeadline: "branding-login-headline",
  brandingSubmit: "branding-submit",
  moduleToggle: (key) => `module-toggle-${key}`,
  modulesSubmit: "modules-submit",
  fieldKey: "field-key",
  fieldLabel: "field-label",
  fieldType: "field-type",
  fieldResource: "field-resource",
  fieldAdd: "field-add",
  fieldRemove: (id) => `field-remove-${id}`,
};
